import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { StaticImage } from "gatsby-plugin-image";
import { ReactComponent as CrossIcon } from "icons/cross.svg";

type Props = {
    children: React.ReactNode;
    showClose?: boolean;
    open: boolean;
    onClose: () => void;
};

export const Modal: React.FC<Props> = ({
    children,
    open,
    showClose,
    onClose,
}) => {
    return (
        <Transition appear show={open} as={Fragment}>
            <Dialog as="div" className="relative z-30" onClose={onClose}>
                <Transition.Child
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <StaticImage
                        src="../images/modal-cover.png"
                        alt="Modal cover"
                        className="!fixed inset-0"
                    />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    {showClose && (
                        <button
                            type="button"
                            className="right-6 top-6 absolute text-white"
                            onClick={onClose}
                        >
                            <CrossIcon width={25} height={25} />
                        </button>
                    )}
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="text-white w-full max-w-[650px] transform overflow-hidden align-middle font-bold">
                                {children}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export const ModalPanel: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return (
        <div className="rounded-lg bg-[#202020] bg-opacity-80 px-5 pt-14 pb-6 md:py-16 mb-4">
            {children}
        </div>
    );
};
